<template>
  <div class="addr-wrap">
    <div class="address-ctrl" @click="showAddrPop" v-if="!address">
      <span class="txt">{{ labelTitle }}</span>
      <span>选择赠品自提门店</span>
      <a href="javascript:" class="btn"><i class="icon-arrow-right"></i></a>
    </div>
    <template v-else>
      <div class="address-view" @click="showAddrPop" v-if="isEditable">
        <div class="bd">
          <div class="info">
            <strong>{{ address.short_name }}</strong>
            <a href="#" class="action"><i class="icon-arrow-right"></i></a>
          </div>
          <div class="desc">
            <div class="group-input">
              <label>自提地点：</label>
              <p>{{ address.address }}</p>
            </div>
            <div class="group-input" v-show="address.start_time">
              <label>自提时间：</label>
              <p>{{ address.start_time }}-{{ address.end_time }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <Popup class="popup" v-model="isShowPopup" position="bottom" :modal="false">
      <top
        title="选择自提点"
        :home="false"
        :evtBack="true"
        @back="hideAddrPop"
        :show="true"
      ></top>
      <div class="bd">
        <address-index
          v-if="isInitialized"
          :selectedId="selectedId"
          :isPopup="true"
          :pickUpPoint="pickUpPoint"
          @useAddress="useAddress"
        ></address-index>
      </div>
    </Popup>
  </div>
</template>

<script>
import { Popup } from 'mint-ui'
import top from './pop-top'
import addressIndex from './pop-address'
export default {
  created() {},
  data() {
    return {
      isShowPopup: false,
      isInitialized: false,
      selectedId: null
    }
  },
  methods: {
    restoreAddress() {
      const json = sessionStorage.getItem('own/address.delivery')
      if (json) {
        const o = JSON.parse(json)
        this.useAddress(o)
        console.log('mail_address restored: ', o)
      }
    },
    showAddrPop() {
      this.isShowPopup = true
      this.isInitialized = true
    },
    hideAddrPop() {
      this.isShowPopup = false
    },
    goAddr() {
      const isCzj = this.$$isCZJApp()
      if (isCzj) {
        location.href = '/my/address'
      } else {
        this.$router.push('/my/address')
      }
    },
    goAddrCreate() {
      const isCzj = this.$$isCZJApp()
      if (isCzj) {
        location.href = '/my/address-add?refresh=no'
      } else {
        this.$router.push('/my/address-add?refresh=no')
      }
    },
    useAddress(item) {
      this.hideAddrPop()
      this.selectedId = item.store_id
      this.$emit('input', item)
    }
  },
  props: {
    value: {
      type: Object
    },
    pickUpPoint: String,
    labelTitle: {
      type: String,
      default: '上门自提'
    },
    edit: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isEditable() {
      return !!this.edit
    },
    address() {
      return this.value
    }
  },
  components: {
    top,
    Popup,
    addressIndex
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.addr-wrap {
  background: #fff;
  border-radius: rem(16px);
  margin-bottom: rem(20px);
}
.address-ctrl {
  position: relative;
  padding: 0 rem(20px);
  height: rem(100px);
  line-height: rem(100px);
  color: #ccc;
  .txt {
    float: left;
    font-size: rem(30px);
    color: #666;
    padding-right: rem(38px);
  }
  .btn {
    float: right;
    padding: 0 rem(20px);
    margin-right: rem(-20px);
    i {
      font-size: rem(30px);
      color: #999;
    }
  }
}
.address-view {
  position: relative;
  padding: 0 rem(20px);
  padding-bottom: rem(24px);
  .bd {
    width: 100%;
    overflow: hidden;
    .info {
      position: relative;
      margin-top: rem(14px);
      padding: rem(16px) rem(32px) rem(16px) 0;
      font-size: rem(32px);
      color: #121212;
      strong {
        font-weight: bold;
        color: #121212;
        margin-right: rem(30px);
      }
      a {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
      }
    }
    .desc {
      font-size: rem(28px);
      line-height: 1.6em;
      overflow: hidden;
      color: #666;
      .group-input {
        overflow: hidden;
        display: flex;
        display: -webkit-flex;
        label {
          white-space: nowrap;
          color: #121212;
        }
      }
    }
  }
  .action {
    display: flex;
    float: right;
    align-items: center;
    i {
      color: #999;
      .icon-arrow-right {
        display: inline-block;
        width: 0.2rem;
        height: 0.2rem;
        background-image: url('~@/assets/images/product/new/icon-arrow-right.png');
        background-size: 0.2rem;
      }
    }
  }
}
.address-bare {
  padding: 0 rem(24px);
  overflow: hidden;
  .info {
    padding: rem(30px) 0 rem(16px);
    font-size: rem(30px);
    color: #121212;
    strong {
      font-weight: normal;
    }
  }
  .desc {
    font-size: rem(28px);
    line-height: 1.6em;
    color: #666;
    padding-bottom: rem(20px);

    p {
      margin-right: rem(76px);
    }
  }
}
.def {
  height: rem(30px);
  line-height: rem(30px);
  padding: 0 rem(13px);
  border: 1px solid #ff4b4b;
  border-radius: rem(15px);
  font-size: rem(20px);
  text-align: center;
  color: #ff4b4b;
  margin-right: rem(10px);
}
.popup {
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  z-index: 999;
  display: flex;
  flex-direction: column;
  .bd {
    position: relative;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
  }
}
</style>
